import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { getDistanceFromLatLon } from 'src/app/utils/utils.common';
import { PlannerHelpingService } from './planner-helping-service';

@Injectable({
  providedIn: 'root'
})
export class PlannerTemplateWiseService {
  selectedMethod;
  constructor(private  assigTripsService:AssigTripsService,
        private plannerHelpingService: PlannerHelpingService) {
  }

  async planTrips(user, preData, selectedDrivers, selectedTemplate, selectedMethod, timeCalibration) {
    this.selectedMethod = selectedMethod;

    const driverMembers = selectedTemplate.reduce((obj, item) => (obj[item.driver] = item.members, obj), {});
    let planedTrips = {
      trips: [],
      nonCompatible: [],
      compatible: {},
      tripLogs: {}
    };

    // convert ids to trips
    for (let trip of preData.trips) {
      if (preData.selectedTrips.includes(trip._id)) {
        planedTrips.trips.push(trip);
      }
    }


//  if (timeCalibration && timeCalibration !== "none") {
//       // set pickup and drop off time
//       for (let trip of planedTrips.trips) {
//         const distance = await this.calculateDistance(
//           trip.jobOriginLatitude,
//           trip.jobOriginLongitude,
//           trip.jobDestinationLatitude,
//           trip.jobDestinationLongitude
//         );

//         if (distance && distance.duration) {
//           if (timeCalibration === "pickup-wise") {
//             trip.scheduleTime = moment(trip.appointmentTime).tz(user.timeZone).subtract(distance.duration, 'minutes').toISOString();
//           } else {
//             trip.appointmentTime = moment(trip.scheduleTime).tz(user.timeZone).add(distance.duration, 'minutes').toISOString();
//           }
//         }
//       }
    //     }

        if (timeCalibration && timeCalibration !== "none") {
      if (timeCalibration === "pickup-wise") {
        await this.plannerHelpingService.applyPickupWiseCalibration(this.selectedMethod,  planedTrips.trips, user);
      } else if (timeCalibration === "dropoff-wise") {
        await this.plannerHelpingService.applyDropoffWiseCalibration(this.selectedMethod,  planedTrips.trips, user);
      } else {
        await this.plannerHelpingService.applyMemberWiseHybridCalibration(this.selectedMethod,  planedTrips.trips, user);
      }
    }

    selectedDrivers.sort((a, b) =>
      a.displayName.localeCompare(
        b.displayName
      )
    );

    planedTrips.trips.sort((a, b) => {
      return moment(a.scheduleTime).tz(user.timeZone).diff(moment(b.scheduleTime).tz(user.timeZone));
    });

    for (const driver of selectedDrivers) {
      const dMembers = driverMembers[driver._id];
      if (!dMembers) continue;
      let nonCompatible = [];
      let compatible = [];
      for (const trip of planedTrips.trips) {
        if (dMembers.includes(trip.client)) {
          compatible.push(trip);
        } else {
          nonCompatible.push(trip);
        }
      }

      if (compatible && compatible.length) {
        planedTrips.compatible[driver._id] = {
          driver,
          trips: compatible
        };
      }

      planedTrips.trips = nonCompatible;
    };
    planedTrips.nonCompatible = planedTrips.trips;
    planedTrips.trips = [];
    return planedTrips;
  }

    async calculateDistance(lat1, lon1, lat2, lon2) {
      let resutl;
      if (this.selectedMethod && this.selectedMethod === true) {
        resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
      } else {
        resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2))});
      }
      return resutl;
    }


    async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
      const res: any = await this.assigTripsService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
      const segments: any = res.features[0].properties.segments;
      return {
        distance: (segments[0].distance / 1609),
        duration: (segments[0].duration / 60)
      };
    }

}

